import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { getAuth } from 'firebase/auth';

const USERS_COLLECTION = 'users';

/**
 * Load margin calculator data for the current user
 * @returns {Promise<Object>} Margin calculator data object
 */
export const loadMarginCalculatorData = async (userId = null) => {
  try {
    const auth = getAuth();
    const uid = userId || auth.currentUser?.uid;
    if (!uid) {
      throw new Error('User must be authenticated to load margin calculator data');
    }

    const userRef = doc(db, USERS_COLLECTION, uid);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      const data = userDoc.data();
      return data.marginCalculator || getDefaultMarginCalculatorData();
    }
    
    return getDefaultMarginCalculatorData();
  } catch (error) {
    console.error('Error loading margin calculator data:', error);
    return getDefaultMarginCalculatorData();
  }
};

/**
 * Save margin calculator data for the current user
 * @param {Object} marginCalculatorData - The margin calculator data to save
 * @returns {Promise<void>}
 */
export const saveMarginCalculatorData = async (marginCalculatorData, userId = null) => {
  try {
    const auth = getAuth();
    const uid = userId || auth.currentUser?.uid;
    if (!uid) {
      throw new Error('User must be authenticated to save margin calculator data');
    }

    const userRef = doc(db, USERS_COLLECTION, uid);
    await setDoc(userRef, {
      marginCalculator: {
        ...marginCalculatorData,
        lastUpdated: new Date().toISOString(),
        version: '1.0'
      }
    }, { merge: true });
  } catch (error) {
    console.error('Error saving margin calculator data:', error);
    throw error;
  }
};

/**
 * Get default margin calculator data structure
 * @returns {Object} Default margin calculator data
 */
const getDefaultMarginCalculatorData = () => {
  return {
    inputs: {
      taxRate: 0.20,
      profitabilityDesire: 0.11,
      startingGPM: 0.30,
      overhead: 260000,
      trueGPM: 0.25
    },
    lastCalculated: null
  };
}; 